import defaultRoutes from "./routes.ts";
import ioRoutes from "@/router/ioRoutes.ts";
import { createRouter, createWebHistory } from "vue-router";
import { ROUTE_SCROLL_DELAY } from "@/utils/variables";
import { loadTld } from "@/utils/storage";
import { useLayoutStore } from "@/store/layout";
import { useModalStore } from "@/store/modal.ts";
import { useUserStore } from "@/store/user.ts";

const tld = loadTld() || window.location.origin.split(".").pop();
const routes = tld === "io" ? ioRoutes : defaultRoutes;

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash === "#") {
      return false;
    }

    if (to.hash.includes("#play-")) {
      return false;
    }

    if (to.hash) {
      const hashEl = to.hash ? document.getElementById(to.hash.replace("#", "")) : null;

      if (hashEl) {
        return {
          el: hashEl,
          behavior: "smooth",
        };
      }

      return false;
    }

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ top: 0 });
      }, ROUTE_SCROLL_DELAY);
    });
  },
});

router.beforeEach(async (to, from, next) => {
  await useModalStore().hideAllModals();

  if (to.meta.lawLimited && useUserStore().hasLawLimitations) {
    next();
    return;
  }

  const layoutStore = useLayoutStore();

  if (from.path !== to.path) {
    layoutStore.setGlobalLoading(true);
  }

  layoutStore.setContentLoaded(false);
  layoutStore.setPagePosition({ path: from.fullPath, top: window.scrollY });

  next();
});
router.afterEach(() => {
  useLayoutStore().setGlobalLoading(false);
});

export default router;
